"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var localization_1 = require("../../../../checkout/localization");
var error_message_1 = __importDefault(require("../../../components/error_message"));
var payment_1 = require("./payment");
var BillingAddress = function () {
    var context = (0, react_1.useContext)(payment_1.PaymentContext);
    var customerData = context.customerData, setFirstName = context.setFirstName, setLastName = context.setLastName, setCompany = context.setCompany, setPhone = context.setPhone, setAddress1 = context.setAddress1, setAddress2 = context.setAddress2, setCity = context.setCity, setProvince = context.setProvince, setZip = context.setZip, setCountry = context.setCountry;
    if (!customerData) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var fieldContainerClassName = function (fieldName) {
        return (0, classnames_1.default)({ 'form-input': true, 'with-error': errors && errors[fieldName], 'is-filled': formValues && !!formValues[fieldName] });
    };
    var _a = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            first_name: customerData.first_name,
            last_name: customerData.last_name,
            company: customerData.billing_company,
            phone: customerData.billing_phone,
            address1: customerData.billing_address1,
            address2: customerData.billing_address2,
            city: customerData.billing_city,
            province: customerData.billing_province,
            country: customerData.billing_country,
            zip: customerData.billing_zip,
        },
    }), register = _a.register, watch = _a.watch, errors = _a.errors;
    var formValues = watch();
    var countryCode = (0, localization_1.isCanadianAddressCountry)(formValues.country) ? 'CA' : 'US';
    var config = localization_1.LocaleConfig[countryCode];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'padding-top-3' }, "Billing Address"),
        react_1.default.createElement("div", { className: 'padding-bottom-3' },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: fieldContainerClassName('country') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("select", { name: 'country', autoComplete: 'country-name', onChange: function (event) { return setCountry && setCountry(event.target.value); }, ref: register({
                                required: 'Required',
                            }) },
                            react_1.default.createElement("option", null, "Select"),
                            react_1.default.createElement("option", { key: 'United States' }, "United States"),
                            react_1.default.createElement("option", { key: 'Canada' }, "Canada")),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Country")),
                    react_1.default.createElement(error_message_1.default, { error: errors.country })),
                react_1.default.createElement("div", { className: fieldContainerClassName('first_name') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'first_name', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', placeholder: 'First Name', onChange: function (event) { return setFirstName && setFirstName(event.target.value); }, ref: register({
                                required: {
                                    value: true,
                                    message: 'First name is required',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "First Name")),
                    react_1.default.createElement(error_message_1.default, { error: errors.first_name })),
                react_1.default.createElement("div", { className: fieldContainerClassName('last_name') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { name: 'last_name', autoComplete: 'family-name', type: 'text', placeholder: 'Last Name', onChange: function (event) { return setLastName && setLastName(event.target.value); }, ref: register({
                                required: {
                                    value: true,
                                    message: 'Last name is required',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Last Name")),
                    react_1.default.createElement(error_message_1.default, { error: errors.last_name })),
                react_1.default.createElement("div", { className: fieldContainerClassName('company') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'company', autoComplete: 'company', onChange: function (company) { return setCompany && setCompany(company.target.value); }, spellCheck: false, autoCapitalize: 'off', placeholder: 'Company', ref: register({
                                required: {
                                    value: false,
                                    message: '',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Company (Optional)")),
                    react_1.default.createElement(error_message_1.default, { error: errors.company })),
                react_1.default.createElement("div", { className: fieldContainerClassName('address1') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'address1', autoComplete: 'address-line1', spellCheck: false, autoCapitalize: 'off', placeholder: 'Address', onChange: function (add1) { return setAddress1 && setAddress1(add1.target.value); }, ref: register({
                                required: {
                                    value: true,
                                    message: 'Address is required',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Address")),
                    react_1.default.createElement(error_message_1.default, { error: errors.address1 })),
                react_1.default.createElement("div", { className: fieldContainerClassName('address2') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'address2', autoComplete: 'address-line2', spellCheck: false, autoCapitalize: 'off', placeholder: 'Apartment, suite, etc. (optional)', onChange: function (add2) { return setAddress2 && setAddress2(add2.target.value); }, ref: register({
                                required: {
                                    value: false,
                                    message: '',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Apartment, suite, etc. (Optional)")),
                    react_1.default.createElement(error_message_1.default, { error: errors.address2 })),
                react_1.default.createElement("div", { className: fieldContainerClassName('city') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'city', autoComplete: 'billing locality', spellCheck: false, autoCapitalize: 'off', placeholder: 'City', onChange: function (city) { return setCity && setCity(city.target.value); }, ref: register({
                                required: {
                                    value: true,
                                    message: 'City is required',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "City")),
                    react_1.default.createElement(error_message_1.default, { error: errors.city })),
                react_1.default.createElement("div", { className: fieldContainerClassName('province') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("select", { name: 'province', autoComplete: 'billing region', onChange: function (province) { return setProvince && setProvince(province.target.value); }, ref: register({
                                required: 'Required',
                            }) },
                            react_1.default.createElement("option", null, "Select"),
                            config.states.map(function (state) { return (react_1.default.createElement("option", { key: state.name, value: state.name }, state.name)); })),
                        react_1.default.createElement("span", { className: 'placeholder' }, config.labels.state)),
                    react_1.default.createElement(error_message_1.default, { error: errors.province })),
                react_1.default.createElement("div", { className: fieldContainerClassName('zip') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'zip', autoComplete: 'billing postal-code', spellCheck: false, autoCapitalize: 'off', placeholder: 'Zip', onChange: function (zip) { return setZip && setZip(zip.target.value); }, ref: register({
                                required: {
                                    value: true,
                                    message: 'ZIP Code is required',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "ZIP Code")),
                    react_1.default.createElement(error_message_1.default, { error: errors.zip })),
                react_1.default.createElement("div", { className: fieldContainerClassName('phone') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { name: 'phone', autoComplete: 'phone', type: 'text', placeholder: 'Phone', onChange: function (phone) { return setPhone && setPhone(phone.target.value); }, ref: register({
                                required: {
                                    value: false,
                                    message: '',
                                },
                                minLength: {
                                    value: 6,
                                    message: 'Phone is too short',
                                },
                                maxLength: {
                                    value: 12,
                                    message: 'Phone is too long',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Phone (Optional)")),
                    react_1.default.createElement(error_message_1.default, { error: errors.phone }))))));
};
exports.default = BillingAddress;
